
import { ClientPortalService } from "@/services";
import Vue from "vue";

export default Vue.extend({
  data() {
    return {
      domain: "",
      locationId: "",
      archiveDomainLocationId: "",
      archiveDomainName: "",
      domainError: "",
      locationIdError: "",
      archiveDomainLocationIdError: "",
      archiveDomainNameError: "",
      isLoadingGet: false,
      isLoadingRemove: false,
      isLoadingArchiveDomain: false,
      getErrorMessage: "",
      getSuccessMessage: "",
      removeErrorMessage: "",
      removeSuccessMessage: "",
      archiveDomainErrorMessage: "",
      archiveDomainSuccessMessage: "",
      portalSettingsData: null,
    };
  },
  methods: {
    clearGetErrors() {
      this.domainError = "";
      this.getErrorMessage = "";
      this.getSuccessMessage = "";
      this.portalSettingsData = null;
    },
    clearRemoveErrors() {
      this.locationIdError = "";
      this.removeErrorMessage = "";
      this.removeSuccessMessage = "";
    },
    clearArchiveDomainErrors() {
      this.archiveDomainLocationIdError = "";
      this.archiveDomainNameError = "";
      this.archiveDomainErrorMessage = "";
      this.archiveDomainSuccessMessage = "";
    },
    async getPortalSettingsByDomain() {
      this.clearGetErrors();
      if (!this.domain) {
        this.domainError = "Domain is required.";
        return;
      }
      try {
        this.isLoadingGet = true;
        const url = `/portal-settings?domain=${this.domain}`;
        const response = await ClientPortalService.getPortalSettingsByDomain(url);
        this.portalSettingsData = response.data;
        this.getSuccessMessage = "Portal settings retrieved successfully.";
      } catch (error: any) {
        this.getErrorMessage =
          error?.response?.data?.message || "An error occurred while fetching portal settings.";
        console.error(error);
      } finally {
        this.isLoadingGet = false;
      }
    },
    async removeDomainFromPortalSettings() {
      this.clearRemoveErrors();
      if (!this.locationId) {
        this.locationIdError = "Location ID is required.";
        return;
      }
      try {
        this.isLoadingRemove = true;
        const url = `/portal-settings/${this.locationId}`;
        const response = await ClientPortalService.removeDomainFromPortalSettingsByLocationId(url);
        this.removeSuccessMessage =
          response.data?.message || "Domain removed from portal settings successfully.";
        this.locationId = "";
      } catch (error: any) {
        this.removeErrorMessage =
          error?.response?.data?.message || "An error occurred while removing the domain.";
        console.error(error);
      } finally {
        this.isLoadingRemove = false;
      }
    },
    async deleteArchiveDomain() {
      this.clearArchiveDomainErrors();
      if (!this.archiveDomainLocationId) {
        this.archiveDomainLocationIdError = "Location ID is required.";
      }
      if (!this.archiveDomainName) {
        this.archiveDomainNameError = "Domain name is required.";
      }
      if (this.archiveDomainLocationIdError || this.archiveDomainNameError) {
        this.archiveDomainErrorMessage = "Please fix the errors above";
        return;
      }
      try {
        this.isLoadingArchiveDomain = true;
        const response = await ClientPortalService.deleteArchiveDomain(
          this.archiveDomainLocationId,
          this.archiveDomainName
        );
        this.archiveDomainSuccessMessage =
          response.data?.message || "Archive domain deleted successfully.";
        this.archiveDomainLocationId = "";
        this.archiveDomainName = "";
      } catch (error: any) {
        this.archiveDomainErrorMessage =
          error?.response?.data?.message || "An error occurred while deleting the archive domain.";
        console.error(error);
      } finally {
        this.isLoadingArchiveDomain = false;
      }
    },
  },
});
